import React from 'react';
import { css, styled } from 'styled-components';

export function ProcessStartWizardCol(props: { children: React.ReactNode; result?: boolean }) {
    return <StyledProcessStartWizardCol $result={props.result}>{props.children}</StyledProcessStartWizardCol>;
}

const StyledProcessStartWizardCol = styled.div<{ $result?: boolean }>`
    ${({ $result }) =>
        $result
            ? css`
                  position: relative;
                  width: 100%;
                  display: inline-block;
                  padding: calc(0.375rem + 1px) 5px;
                  margin-bottom: 0;
                  font-size: inherit;
                  min-height: calc(2.25rem + 2px);
                  line-height: 1.5;

                  ${({ theme }) => theme.mediaQueries.medium} {
                      flex-basis: 0;
                      flex-grow: 1;
                      min-width: 0;
                      max-width: 100%;
                  }
              `
            : css`
                   {
                      flex: 2;
                      min-width: 0;
                      max-width: 100%;
                      position: relative;
                      padding-right: 15px;
                      padding-left: 15px;
                  }
              `}
`;
